import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../redux/features/authSlice";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";

// Validation schema
const validationSchema = yup.object({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginLoading } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(loginUser(values))
        .unwrap()
        .then(() => {
          toast.success("Login successful!", {
            position: "top-center",
            theme: "colored",
          });
          navigate("/");
        })
        .catch((err) => {
          toast.error(err, {
            position: "top-center",
            theme: "colored",
          });
        });
    },
  });

  return (
    <div>
      <main className="main pages">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span> Login</span>
            </div>
          </div>
        </div>
        <div className="page-content pt-50 pb-150">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                <div className="row" style={{ alignItems: "center" }}>
                  <div className="col-lg-6 pr-30 d-none d-lg-block">
                    <img
                      className="border-radius-15"
                      src="assets/imgs/page/1.png"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6 col-md-8">
                    <div className="login_wrap widget-taber-content background-white">
                      <div className="padding_eight_all bg-white">
                        <div className="heading_s1">
                          <h1 className="mb-5">Login</h1>
                          <p className="mb-30">
                            Don't have an account?
                            <Link to={"/signup"}>
                              <a style={{ marginLeft: "4px" }}>Create here</a>
                            </Link>
                          </p>
                        </div>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="form-group">
                            <input
                              type="email"
                              name="email"
                              placeholder="Enter your email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={
                                formik.touched.email && formik.errors.email
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                            {formik.touched.email && formik.errors.email ? (
                              <div className="text-danger">
                                {formik.errors.email}
                              </div>
                            ) : null}
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              name="password"
                              placeholder="Enter your password"
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={
                                formik.touched.password &&
                                formik.errors.password
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            />
                            {formik.touched.password &&
                            formik.errors.password ? (
                              <div className="text-danger">
                                {formik.errors.password}
                              </div>
                            ) : null}
                          </div>

                          <div className="login_footer form-group mb-50">
                            <div className="chek-form">
                              <div className="custome-checkbox">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="checkbox"
                                  id="exampleCheckbox1"
                                  defaultValue=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="exampleCheckbox1"
                                >
                                  <span>Remember me</span>
                                </label>
                              </div>
                            </div>
                            <Link to={"/forgotpassword"}>
                              Forget Password ?
                            </Link>
                          </div>
                          <div
                            className="form-group mb-30"
                            style={{ width: "100%" }}
                          >
                            <button
                              className="btn btn-fill-out btn-block hover-up font-weight-bold"
                              type="submit"
                              style={{ width: "100%" }}
                              disabled={loginLoading}
                            >
                              {loginLoading ? (
                                <CircularProgress size={20} color="inherit" />
                              ) : (
                                "Login"
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
